import { useMemo } from 'react';
import { ChartData, ChartDataset, ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import DistrictGradebook from 'models/analytics/DistrictGradebook';

interface ClassroomComparisonChartProps {
  gradebook: DistrictGradebook;
}

const COLORS = [
  '#e6194b', // red
  '#3cb44b', // green
  '#ffe119', // yellow
  '#0082c8', // blue
  '#f58231', // orange
  '#911eb4', // purple
  '#46f0f0', // cyan
  '#f032e6', // magenta
  '#d2f53c', // lime
  '#fabebe', // pink
  '#008080', // teal
  '#e6beff', // lavender
  '#aa6e28', // brown
  '#fffac8', // beige
  '#800000', // maroon
  '#aaffc3', // mint
  '#808000', // olive
  '#ffd8b1', // apricot
  '#000080', // navy
  '#808080', // gray
];

const ClassroomComparisonChart: React.FC<ClassroomComparisonChartProps> = ({
  gradebook,
}) => {
  const snapshotChartData = useMemo<ChartData<'bar'>>(() => {
    var datasets: ChartDataset<'bar', (number | [number, number] | null)[]>[] =
      [];
    const entries = gradebook.entries;
    datasets.push({
      label: `Average`,
      data: [
        gradebook.averages.grade,
        gradebook.averages.completion_score,
        gradebook.averages.correctness_score,
        gradebook.averages.key_word_accuracy_score,
      ],
      backgroundColor: COLORS[0],
      borderColor: COLORS[0],
      borderWidth: 1,
    });
    Object.keys(entries).forEach((key, idx) => {
      const g = entries[key];
      console.log(entries, entries[key]);
      datasets.push({
        label: `Class ${key}`,
        data: [
          g.grade,
          g.completion_score,
          g.correctness_score,
          g.key_word_accuracy_score,
        ],
        backgroundColor: COLORS[(idx + 1) % COLORS.length],
        borderColor: COLORS[(idx + 1) % COLORS.length],
        borderWidth: 1,
      });
    });
    return {
      labels: ['Grade', 'Completion', 'Accuracy', 'Key Word Accuracy'],
      datasets: datasets,
    };
  }, [gradebook.entries, gradebook.averages]);

  const snapshotChartOptions = useMemo<ChartOptions<'bar'>>(() => {
    return {
      responsive: true,
      scales: {
        x: {
          type: 'category',
          title: { display: true, text: 'Metrics' },
        },
        y: {
          type: 'linear',
          beginAtZero: true,
          title: { display: true, text: 'Value' },
        },
      },
    };
  }, []);
  return <Bar data={snapshotChartData} options={snapshotChartOptions} />;
};

export default ClassroomComparisonChart;
